<template>
  <div id="app">
    <router-view />
    <div class="side" @click="sideClick">
      <img src="@/assets/img/AI.gif" alt=""></img>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    sideClick() {
      //跳转到其他网站，不是在新的页面打开
      window.location.href = "https://chat.baidu.com/search?isShowHello=1&pd=csaitab&setype=csaitab&extParamsJson=%7B%22enter_type%22%3A%22ai_explore_home%22%7D&usedModel=%7B%22modelName%22%3A%22DeepSeek-R1%22%7D";
    }
  }
}
</script>
<style lang="less">
body {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
  /* 去掉下划线 */
  color: inherit;
  /* 继承父元素的颜色 */
  cursor: pointer;
  /* 鼠标悬停时显示指针 */
  outline: none;
  /* 去掉聚焦时的默认轮廓 */
}

.side {
  width: 8rem;
  height: 11rem;
  position: fixed;
  top: 50%;
  left: .625rem;
  transform: translate(0, -50%);
  cursor: pointer;
  z-index: 999;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>